import { nanoid } from 'nanoid/async'
import { genericTemplateModal } from './genericTemplateModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: genericTemplateData } = await genericTemplateModal(oldData, node)

  if (genericTemplateData && Object.values(genericTemplateData).length >= 1) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }    
    
    Object.assign(node.data, genericTemplateData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}